import { useEffect } from 'react';
import M from 'materialize-css/dist/js/materialize.min';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const Divisions = () => {
  useEffect(() => {
    var cara = document.querySelectorAll('.carousel');
    M.Carousel.init( cara,  {
      padding: 90
    })
  }, [])

  return ( 
    <div className="section light-bg" id="division-home">
      <h5 className="title has-text-weight-bold mt-5 mb-2 center grey-text text-darken-3"><span className="has-text-weight-normal">Our</span> Divisions</h5>
      <div className="divider"></div>
    
      <div className="carousel">
          <div href="#one!" className="carousel-item">
            <Link to="/division/artsAndScience" className="make-red-text-hover">
              <img src="/img/subject/applied-art.jpg" className="responsive-img" alt="Applied Arts" />
              <p className="center main-color-text is-size-5 mt-2 has-text-weight-semibold">
                Applied Arts & Science
                <FaArrowRight className="main-color-text ml-2 pt-1" />
              </p>
            </Link>
          </div>
          <div href="#two!" className="carousel-item">
            <Link to="/division/ccd">
              <img src="/img/subject/civil-eng.jpg" className="responsive-img" alt="Civil Enineering" />
              <p className="center main-color-text is-size-5 mt-2 has-text-weight-semibold">
                Civil & Construction
                <FaArrowRight className="main-color-text ml-2 pt-1" />
              </p>
            </Link>
          </div>
          <div href="#three!" className="carousel-item">
            <Link to="/division/engineering">
              <img src="/img/subject/mech-eng.jpg" className="responsive-img" alt="Engineering" />
              <p className="center main-color-text is-size-5 mt-2 has-text-weight-semibold">
                Engineering
                <FaArrowRight className="main-color-text ml-2 pt-1" />
              </p>
            </Link>
          </div>
          <div href="#four!" className="carousel-item">
            <Link to="/division/commerce">
              <img src="/img/subject/business-studies.jpg" className="responsive-img" alt="Commerce" />
              <p className="center main-color-text is-size-5 mt-2 has-text-weight-semibold">
                Commerce
                <FaArrowRight className="main-color-text ml-2 pt-1" />
              </p>
            </Link>
          </div>
          <div href="#five!" className="carousel-item">
            <Link to="/division/reed">
              <img src="/img/subject/teach.jpg" className="responsive-img" alt="Teach" />
              <p className="center main-color-text is-size-5 mt-2 has-text-weight-semibold">
                Research Education &amp; <br />Enterprise Development </p>
            </Link>
          </div>         
      </div>
  </div>
   );
}
 
export default Divisions;
  
